module.exports = __webpack_public_path__ + "d2e60287b98dfa5e1e4a8b819e4497df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/19_CP637-001-PLANE-3.png
// module id = 120
// module chunks = 0